/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import { numberFormat } from 'helper';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../actions';
import * as c from '../constants';

function UpdateModal({
  officialReceiptList,
  id,
  item,
  createInput,
  updateOfficialReceipt,
  formData,
  setFormData,
  getOfficialReceipts,
  updating,
  triggerParentEffect,
  moduleType,
}) {
  const allFees = _.flatMap(officialReceiptList, 'fees');

  useEffect(() => {
    setFormData({
      number: item.number,
      date: moment(item.date).format('MM/DD/YYYY'),
    });
  }, []);

  const [formDataFees, setFormDataFees] = useState({
    orFees: item.fees.map((val) => {
      const orFee = `${val.name} | ${val.amount}`;

      if (moduleType === 'BPLS') {
        return `${orFee} | ${val.year}`;
      }

      return orFee;
    }),
  });

  let feesItems = JSON.parse(localStorage.getItem('feesItems'));

  feesItems = feesItems.filter((feeItem) => {
    const parts = feeItem.value.split('|').map((item) => item.trim());
    const [name, amount, year] = parts;

    return !allFees.some((allFee) => {
      // Always check name 
      const matchNameAmount = allFee.name === name 

      // If year exists in both
      if (moduleType === 'BPLS') {
        return matchNameAmount && allFee.year === year;
      }

      // Otherwise just match on name + amount
      return matchNameAmount;
    });
  });

  const [feesOption, setFeesOption] = useState(feesItems);

  const formatNumberWithoutComma = (value) => {
    // Remove commas from the value and return it
    return value.replace(/,/g, '');
  };

  const setModal = useContext(ModalContext);

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const transformedFees = formDataFees.orFees.map((fee) => {
      const [name, amount, year] = fee.split('|').map((item) => item.trim());

      if (moduleType === 'BPLS') {
        return { 
          name, 
          amount: formatNumberWithoutComma(amount),
          year 
        };
      }

      return { 
        name, 
        amount 
      };
    });

    const newFormData = {
      ...formData,
      fees: transformedFees,
      date: moment(formData.date).format('YYYY-MM-DD'),
    };

    updateOfficialReceipt(id, newFormData, ({ data }) => {
      setModal({ isOpen: false });
      getOfficialReceipts();
      if (triggerParentEffect) {
        triggerParentEffect();
      }
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const formatNumber = (value) => {
    const numberValue = parseFloat(value);

    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: false,
    }).format(numberValue);
  };

  const handleSelectChange = (selectedOptions, key) => {
    if (key !== 'orFees') return;

    // Map the selected options to their values
    const newValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];

    // Get the old values from the state
    const oldValues = formDataFees.orFees;

    // Detect removed values
    const removedValues = oldValues.filter(
      (oldValue) => !newValues.includes(oldValue)
    );

    // Detect added values
    const addedValues = newValues.filter(
      (newValue) => !oldValues.includes(newValue)
    );

    // Log removed and added values for debugging
    if (removedValues.length > 0) {
      console.log('Removed values:', removedValues);

      removedValues.forEach((removedValue) => {
        const parts = removedValue.split('|').map((item) => item.trim());
        const [name, amount, year] = parts;

        // set label/value dynamically — only include year if it exists
        const labelValue =
          year !== undefined && year !== ''
            ? `${name} | ${formatNumberWithoutComma(amount)} | ${year}`
            : `${name} | ${formatNumberWithoutComma(amount)}`;

        const result = {
          label: labelValue,
          value: labelValue,
        };

        setFeesOption((prev) => {
          const exists = prev.some((opt) => opt.value === result.value);
          return exists ? prev : [...prev, result];
        });
      });
    }

    if (addedValues.length > 0) {
      console.log('Added values:', addedValues);
      // Handle added values logic here
    }

    // Update the state with the new values
    setFormDataFees((prev) => ({
      ...prev,
      [key]: newValues,
    }));
  };

  const getNotificationEventValues = () => {
    return (formDataFees.orFees || []).map((val) => {
      const matchingOption = feesItems.find((item) => item.value === val);
      return matchingOption || { label: val, value: val };
    });
  };

  const getAmountFromFee = (feeString) => {
    // Return 0 if feeString is null or undefined
    if (feeString == null) {
      return 0;
    }

    try {
      const [, amount] = feeString.split('|').map((item) => item?.trim() || '');
      // Convert to number and handle NaN case
      const parsedAmount = parseFloat(amount);
      // Return the parsed amount if it's a valid number (including 0), otherwise return 0
      return !isNaN(parsedAmount) ? parsedAmount : 0;
    } catch (error) {
      // Return 0 if any error occurs during parsing
      return 0;
    }
  };

  const totalAmount = (formDataFees?.orFees || []).reduce((sum, fee) => {
    return sum + getAmountFromFee(fee);
  }, 0);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'number', label: 'OR Number:' },
              { required: true, placeholder: 'Input OR Number' }
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Date:
              <span className="text-danger">
                {' '}
                <i>Required</i>{' '}
              </span>
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date')}
              value={_.get(formData, 'date') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Fees:
              <span className="text-danger">
                {' '}
                <i>Required</i>{' '}
              </span>
            </label>
            <Select
              value={formDataFees.orFees.map((val) => ({
                label: val,
                value: val,
              }))}
              isMulti
              closeMenuOnSelect={false}
              name="orFees"
              options={feesOption}
              className="basic-multi-select mb-3"
              classNamePrefix="select"
              placeholder="Fees..."
              isClearable={false}
              onChange={(e) => handleSelectChange(e, 'orFees')}
            />

            <small className="text-muted">
              Total Amount Added:{' '}
              <span
                className={`${
                  totalAmount <= 0 ? 'text-danger' : 'text-success'
                } font-weight-bold`}
              >
                ₱ {numberFormat(totalAmount || 0)}
              </span>
            </small>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || totalAmount <= 0}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  updateOfficialReceipt: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  getOfficialReceipts: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  moduleType: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  officialReceiptList: _.get(api, `${c.GET_OFFICIAL_RECEIPTS}.list`) || [],
  updating: api.loading.indexOf(c.CREATE_OFFICIAL_RECEIPT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
